<template>
  <v-container>
    <a id="personData"></a>
    <v-card-title class="text-h5 text-primary mt-3">Informações Pessoais <v-divider inset></v-divider></v-card-title>
    <v-row dense>
      <v-col cols="12" md="6">
        <v-text-field :disabled="$store.getters.getProcess.status == ! 'started'" v-model="form.full_name"
          label="Nome completo*" :rules="[$rules.required]" variant="outlined" required />
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field :disabled="$store.getters.getProcess.status == ! 'started'" v-model="form.social_name"
          label="Nome social" variant="outlined" />
      </v-col>

      <v-col cols="6" md="3">
        <v-autocomplete v-model="form.country_of_origin" :items="countries" label="País de origem*" :rules="[$rules.required]"
          :disabled="$store.getters.getProcess.status == ! 'started'" variant="outlined" required />
      </v-col>

      <v-col cols="6" md="3">
        <v-text-field :disabled="$store.getters.getProcess.status == ! 'started'" v-model="form.rg" label="RG*"
          :rules="[$rules.required]" variant="outlined" required />
      </v-col>

      <v-col cols="6" md="3">
        <v-text-field :disabled="$store.getters.getProcess.status == ! 'started'" v-model="form.cpf" label="CPF*"
          :rules="[$rules.required]" variant="outlined" required v-mask-cpf />
      </v-col>

      <v-col cols="6" md="3">
        <v-text-field :disabled="$store.getters.getProcess.status == ! 'started'" v-model="form.primary_email"
          label="E-mail*" :rules="[$rules.required, $rules.email]" variant="outlined" required />
      </v-col>

      <v-col cols="6" md="3">
        <v-text-field :disabled="$store.getters.getProcess.status == ! 'started'" v-model="form.alternative_email"
          :rules="[$rules.email]" label="E-mail alternativo" variant="outlined" required />
      </v-col>

      <v-col cols="6" md="3" v-if="form.country_of_origin !== 'Brasil' && form.country_of_origin">
        <v-text-field :disabled="$store.getters.getProcess.status == ! 'started'" v-model="form.rne" label="RNE"
          variant="outlined" />
      </v-col>

      <v-col cols="6" md="3" v-if="form.country_of_origin !== 'Brasil' && form.country_of_origin">
        <v-text-field :disabled="$store.getters.getProcess.status == ! 'started'" v-model="form.passport"
          label="Passaporte" variant="outlined" />
      </v-col>

      <v-col cols="6" md="3">
        <v-text-field :disabled="$store.getters.getProcess.status == ! 'started'" v-model="form.date_of_birth"
          label="Data de nascimento*" type="date" :rules="[$rules.required]" variant="outlined" required />
      </v-col>

      <v-col cols="6" md="2">
        <v-select v-model="form.gender" :disabled="$store.getters.getProcess.status == ! 'started'" :items="genders"
          label="Gênero*" :rules="[$rules.required]" variant="outlined" required />
      </v-col>

      <v-col cols="6" md="2">
        <v-select v-model="form.marital_status" :items="maritalStatusList" label="Estado civil*"
          :rules="[$rules.required]" variant="outlined" required />
      </v-col>

      <v-col cols="12" md="2">
        <v-switch v-model="form.has_special_needs" label="Possui necessidades especiais?" color="primary" inset />
      </v-col>

      <v-col cols="6" md="6" v-if="form.has_special_needs">
        <v-textarea v-model="form.special_needs_description" label="Descrição das necessidades especiais*"
          :rules="[$rules.required]" variant="outlined" required />
      </v-col>
    </v-row>
    <v-card-title class="text-h5 text-primary mt-3">Endereço <v-divider inset></v-divider></v-card-title>
    <v-row dense>
      <v-col cols="4">
        <v-autocomplete :disabled="$store.getters.getProcess.status == ! 'started'" :items="countries" v-model="form.country" label="País"
          :rules="[$rules.required]" variant="outlined" />
      </v-col>
      <v-col cols="4">
        <v-text-field maxlength="10" :disabled="$store.getters.getProcess.status == ! 'started'" v-model="form.zip_code"
          @update:modelValue="getAddressByCEP" label="CEP" :rules="[$rules.required]" variant="outlined" />
      </v-col>
      <v-col cols="4">
        <v-text-field :disabled="$store.getters.getProcess.status == ! 'started'" v-model="form.street" label="Rua"
          :rules="[$rules.required]" variant="outlined" />
      </v-col>

      <v-col cols="3">
        <v-text-field :disabled="$store.getters.getProcess.status == ! 'started'" v-model="form.address_complement"
          label="Complemento" variant="outlined" />
      </v-col>

      <v-col cols="3">
        <v-text-field :disabled="$store.getters.getProcess.status == ! 'started'" v-model="form.district" label="Bairro"
          :rules="[$rules.required]" variant="outlined" />
      </v-col>

      <v-col cols="3">
        <v-text-field :disabled="$store.getters.getProcess.status == ! 'started'" v-model="form.city" label="Cidade"
          :rules="[$rules.required]" variant="outlined" />
      </v-col>

      <v-col cols="3">
        <v-text-field :disabled="$store.getters.getProcess.status == ! 'started'" v-model="form.state" label="Estado"
          :rules="[$rules.required]" variant="outlined" />
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import { getCountries } from '@/services/countriesService';
export default {
  data() {
    return {
      valid: false,
      drawer: true,
      activeId: null,
      dialogConfirmSave: false,
      genders: ["Masculino", "Feminino", "Outro"],
      maritalStatusList: ["Solteiro", "Casado", "Divorciado", "Viúvo"],
      countries: [],
      form: {},
      address: null,
    };
  },

  async created() {
    this.form = { ...this.generalData }
    await this.initializeCountries()

  },
  watch: {
    form: {
      deep: true,
      handler(novoValor) {
        this.$emit('editedInputs', { ...novoValor });
      }
    },
    generalData: {
      deep: true,
      handler(novoValor) {
        this.form = { ...novoValor };
      }
    }
  },

  props: {
    generalData: {
      type: Object,
      required: true,
      default: () => ({
        full_name: null,
        social_name: null,
        date_of_birth: null,
        gender: null,
        marital_status: null,
        country_of_origin: null,
        rg: null,
        cpf: null,
        has_special_needs: false,
        special_needs_description: null,
        primary_email: null,
        alternative_email: null,
        phones: null,
        country: null,
        street: null,
        address_complement: null,
        district: null,
        city: null,
        state: null,
        zip_code: null,
      })
    }
  },


  methods: {
    updateInputs() {
      this.$emit('editedInputs', { ...this.form })
    },
    getAddressByCEP(cep) {
      this.$axios.get(`https://viacep.com.br/ws/${cep}/json`)
        .then(response => {
          if (!cep || cep.length < 8) return;
          this.address = response.data
          // Opcional: atualizar outros campos com base na resposta
          this.form.street = response.data.logradouro;
          this.form.district = response.data.bairro;
          this.form.city = response.data.localidade;
          this.form.state = response.data.uf;
        })
        .catch(error => {
          console.error('Erro na requisição GET:', error);
        })
    },
    async initializeCountries() {
      this.countries = await getCountries();
    }

  }
};
</script>